import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * Return message logs for the given user by id
 */
export const selectUserMessageLogs = (state, userId, searchParams) => {
    var _a;
    const searchParamsStr = searchParamsToString(searchParams);
    return (_a = state.userLogs.messageLogsByUserId[userId]) === null || _a === void 0 ? void 0 : _a[searchParamsStr];
};
/**
 * Return http logs for the given user by id
 */
export const selectUserHttpLogs = (state, userId, searchParams) => {
    var _a;
    const searchParamsStr = searchParamsToString(searchParams);
    return (_a = state.userLogs.httpLogsByUserId[userId]) === null || _a === void 0 ? void 0 : _a[searchParamsStr];
};
